import React, { useRef } from 'react';
import { X, Copy, Download } from 'lucide-react';
import { jsPDF } from 'jspdf';
import ReactMarkdown from 'react-markdown';

const AIInsightsModal = ({ isOpen, onClose, title, content, projectName }) => {
    const contentRef = useRef(null);

    if (!isOpen) return null;

    const handleCopy = () => {
        if (contentRef.current) {
            const text = contentRef.current.innerText;
            navigator.clipboard.writeText(text).then(() => {
                alert('Teks berjaya disalin!');
            }).catch(err => {
                console.error('Failed to copy:', err);
                alert('Gagal menyalin teks');
            });
        }
    };

    const handlePrintPDF = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 20;
        const maxWidth = pageWidth - (margin * 2);
        
        // Add title
        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.text(title, margin, margin);
        
        // Add project name
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`Projek: ${projectName}`, margin, margin + 8);
        doc.text(`Tarikh: ${new Date().toLocaleDateString('ms-MY')}`, margin, margin + 14);
        
        // Add content
        doc.setFontSize(11);
        const lines = doc.splitTextToSize(content || 'Tiada kandungan', maxWidth);
        
        let y = margin + 24;
        lines.forEach((line, index) => {
            if (y > pageHeight - margin) {
                doc.addPage();
                y = margin;
            }
            doc.text(line, margin, y);
            y += 6;
        });
        
        // Save PDF
        const filename = `${title.replace(/\s+/g, '_')}_${new Date().getTime()}.pdf`;
        doc.save(filename);
    };

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 sm:p-4">
            <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-w-3xl w-full max-h-[92vh] sm:max-h-[90vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-4 sm:p-6 border-b border-slate-200">
                    <div>
                        <h2 className="text-lg sm:text-xl font-bold text-slate-800">{title}</h2>
                        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{projectName}</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        <X size={20} className="text-slate-500" />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-4 sm:p-6">
                    <div
                        ref={contentRef}
                        className="prose prose-sm max-w-none text-slate-700"
                    >
                        <ReactMarkdown>{content || 'Tiada kandungan tersedia.'}</ReactMarkdown>
                    </div>
                </div>

                {/* Footer Actions */}
                <div className="flex items-center justify-end gap-2 sm:gap-3 p-4 sm:p-6 border-t border-slate-200 bg-slate-50 safe-area-bottom">
                    <button
                        onClick={handleCopy}
                        className="flex items-center gap-1.5 px-3 sm:px-4 py-2 sm:py-2.5 bg-blue-500 hover:bg-blue-600 text-white text-xs sm:text-sm font-semibold rounded-xl transition-colors active:scale-95"
                    >
                        <Copy size={14} />
                        Salin
                    </button>
                    <button
                        onClick={handlePrintPDF}
                        className="flex items-center gap-1.5 px-3 sm:px-4 py-2 sm:py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white text-xs sm:text-sm font-semibold rounded-xl transition-colors active:scale-95"
                    >
                        <Download size={14} />
                        PDF
                    </button>
                    <button
                        onClick={onClose}
                        className="flex items-center gap-1.5 px-3 sm:px-4 py-2 sm:py-2.5 bg-slate-200 hover:bg-slate-300 text-slate-700 text-xs sm:text-sm font-semibold rounded-xl transition-colors active:scale-95"
                    >
                        Tutup
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AIInsightsModal;
